import { __assign } from "tslib";
import { IconButton } from './IconButton';
import { Button } from './Button';
import React from 'react';
import { colors } from '../../theme';
import { Typography } from './Typography';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { TextInput } from './TextInput';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
export var TargetInputModal = function (_a) {
    var icon = _a.icon, _b = _a.title, title = _b === void 0 ? 'Confirm' : _b, textInputValue = _a.textInputValue, _c = _a.autoComplete, autoComplete = _c === void 0 ? false : _c, autoCompleteValue = _a.autoCompleteValue, autoCompleteOptions = _a.autoCompleteOptions, onClickCloseButton = _a.onClickCloseButton, onChangeTextInput = _a.onChangeTextInput, onClickConfirm = _a.onClickConfirm, _d = _a.confirmButtonLabel, confirmButtonLabel = _d === void 0 ? 'OK' : _d, _e = _a.width, width = _e === void 0 ? 'fit-content' : _e, _f = _a.height, height = _f === void 0 ? '134px' : _f, style = _a.style;
    var handleTextInputChange = function (event) {
        if (onChangeTextInput) {
            onChangeTextInput(event.target.value);
        }
    };
    var handleAutocompleteInputChange = function (event, value) {
        if (onChangeTextInput) {
            onChangeTextInput(value);
        }
    };
    return (React.createElement("div", { style: {
            width: width,
            minWidth: '431px',
            height: height,
            minHeight: '134px',
            border: "1px solid ".concat(colors.yellow[50]),
            borderRadius: '6px',
            backgroundColor: colors.white,
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '15px',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingBottom: '26px',
            gap: '18px'
        } },
        React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'space-between'
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center'
                } },
                icon,
                " ",
                React.createElement(Typography, { variant: 'title-regular' }, title)),
            React.createElement(IconButton, { icon: faTimes, variant: 'gray', onClick: onClickCloseButton })),
        React.createElement("div", { style: {
                display: 'flex',
                gap: '18px',
                width: '100%'
            } },
            autoComplete ?
                React.createElement("div", { style: { width: 266 } },
                    React.createElement(Autocomplete, { freeSolo: true, autoSelect: true, options: autoCompleteOptions, value: autoCompleteValue, onChange: handleAutocompleteInputChange, fullWidth: true, size: 'small', renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { 
                            // onChange={handleTextInputChange}
                            fullWidth: true, placeholder: 'Enter Principal', sx: { fontFamily: 'IBM Plex Sans' } }))); } }))
                :
                    React.createElement(TextInput, { placeholder: 'Enter Principal', value: textInputValue, onChange: handleTextInputChange, sx: {
                            fontSize: 14,
                            width: '265px'
                        } }),
            React.createElement(Button, { width: '124px', variant: 'primary', size: 'md', onClick: onClickConfirm },
                React.createElement(Typography, { variant: 'button-sm', style: { color: colors.white } }, confirmButtonLabel)))));
};
